import React from "react";
import AuthReducer from "./AuthReducer";

interface AuthContextProps {
  user: {
    id: string | null;
    name: string | null;
    token: string | null;
    email: string | null;
  };
  isAuthenticated: boolean;
  isLoading: boolean;
  setUser: (value?: any) => void;
  logOut: () => void;
}

export const AuthContext = React.createContext<AuthContextProps>({
  user: {
    name: null,
    email: null,
    id: null,
    token: null,
  },
  isAuthenticated: false,
  isLoading: true,
  setUser: () => {},
  logOut: () => {},
});

const Provider = AuthContext.Provider;

export function AuthState({ children }: React.PropsWithChildren) {
  const initialValue = {
    user: { email: null, token: null, id: null },
    isAuthenticated: false,
    isLoading: true,
  };

  const [state, dispatch] = React.useReducer(AuthReducer, initialValue);

  const setUser = async (value: any) => {
    dispatch({
      payload: value,
      type: "SET_USER",
    });
  };

  const logOut = async () => {
    dispatch({
      payload: {
        ...initialValue,
        isLoading: false,
      },
      type: "LOG_OUT",
    });
  };

  return <Provider value={{ ...state, setUser, logOut }}>{children}</Provider>;
}
